/**
 * Pricing Configuration for Rocket Van Express
 * Contains distance matrix, base rates, and add-on pricing
 */

// Suburb zones for distance calculation
export const suburbZones = {
  // Zone 1: Stellenbosch Central
  'stellenbosch': { zone: 1, name: 'Stellenbosch', lat: -33.9321, lng: 18.8602 },
  'stellenbosch central': { zone: 1, name: 'Stellenbosch Central', lat: -33.9321, lng: 18.8602 },
  'die boord': { zone: 1, name: 'Die Boord', lat: -33.9401, lng: 18.8551 },
  'mostertsdrift': { zone: 1, name: 'Mostertsdrift', lat: -33.9281, lng: 18.8751 },
  'dalsig': { zone: 1, name: 'Dalsig', lat: -33.9251, lng: 18.8501 },
  'kayamandi': { zone: 1, name: 'Kayamandi', lat: -33.9151, lng: 18.8501 },
  
  // Zone 2: Stellenbosch Extended
  'paradyskloof': { zone: 2, name: 'Paradyskloof', lat: -33.9651, lng: 18.8651 },
  'jamestown': { zone: 2, name: 'Jamestown', lat: -33.9481, lng: 18.8351 },
  'welgevonden': { zone: 2, name: 'Welgevonden', lat: -33.9051, lng: 18.8251 },
  'cloetesville': { zone: 2, name: 'Cloetesville', lat: -33.9101, lng: 18.8401 },
  
  // Zone 3: Somerset West / Strand
  'somerset west': { zone: 3, name: 'Somerset West', lat: -34.0781, lng: 18.8431 },
  'strand': { zone: 3, name: 'Strand', lat: -34.1061, lng: 18.8292 },
  'gordons bay': { zone: 3, name: 'Gordons Bay', lat: -34.1616, lng: 18.8673 },
  'heldervue': { zone: 3, name: 'Heldervue', lat: -34.0851, lng: 18.8251 },
  
  // Zone 4: Paarl / Wellington
  'paarl': { zone: 4, name: 'Paarl', lat: -33.7141, lng: 18.9644 },
  'wellington': { zone: 4, name: 'Wellington', lat: -33.6439, lng: 19.0102 },
  'franschhoek': { zone: 4, name: 'Franschhoek', lat: -33.9135, lng: 19.1162 },
  
  // Zone 5: Northern Suburbs
  'bellville': { zone: 5, name: 'Bellville', lat: -33.9017, lng: 18.6283 },
  'durbanville': { zone: 5, name: 'Durbanville', lat: -33.8313, lng: 18.6476 },
  'brackenfell': { zone: 5, name: 'Brackenfell', lat: -33.8761, lng: 18.6961 },
  'kraaifontein': { zone: 5, name: 'Kraaifontein', lat: -33.8501, lng: 18.7301 },
  'parow': { zone: 5, name: 'Parow', lat: -33.9051, lng: 18.5801 },
  'goodwood': { zone: 5, name: 'Goodwood', lat: -33.9101, lng: 18.5551 },
  
  // Zone 6: Cape Town CBD / Atlantic Seaboard
  'cape town': { zone: 6, name: 'Cape Town CBD', lat: -33.9249, lng: 18.4241 },
  'cape town cbd': { zone: 6, name: 'Cape Town CBD', lat: -33.9249, lng: 18.4241 },
  'gardens': { zone: 6, name: 'Gardens', lat: -33.9351, lng: 18.4151 },
  'sea point': { zone: 6, name: 'Sea Point', lat: -33.9151, lng: 18.3851 },
  'green point': { zone: 6, name: 'Green Point', lat: -33.9051, lng: 18.4001 },
  'waterfront': { zone: 6, name: 'V&A Waterfront', lat: -33.9051, lng: 18.4201 },
  'camps bay': { zone: 6, name: 'Camps Bay', lat: -33.9501, lng: 18.3751 },
  
  // Zone 7: Southern Suburbs
  'claremont': { zone: 7, name: 'Claremont', lat: -33.9851, lng: 18.4651 },
  'rondebosch': { zone: 7, name: 'Rondebosch', lat: -33.9651, lng: 18.4751 },
  'newlands': { zone: 7, name: 'Newlands', lat: -33.9751, lng: 18.4551 },
  'constantia': { zone: 7, name: 'Constantia', lat: -34.0251, lng: 18.4251 },
  'wynberg': { zone: 7, name: 'Wynberg', lat: -34.0001, lng: 18.4651 },
  'kenilworth': { zone: 7, name: 'Kenilworth', lat: -33.9951, lng: 18.4801 },
  'observatory': { zone: 7, name: 'Observatory', lat: -33.9401, lng: 18.4701 },
  'mowbray': { zone: 7, name: 'Mowbray', lat: -33.9501, lng: 18.4751 },
};

// Distance matrix between zones (in km approx)
export const zoneDistanceMatrix = {
  // Zone 1 (Stellenbosch Central) to other zones
  '1-1': 5, '1-2': 8, '1-3': 25, '1-4': 25, '1-5': 30, '1-6': 50, '1-7': 45,
  // Zone 2 (Stellenbosch Extended)
  '2-1': 8, '2-2': 5, '2-3': 22, '2-4': 28, '2-5': 32, '2-6': 52, '2-7': 47,
  // Zone 3 (Somerset West)
  '3-1': 25, '3-2': 22, '3-3': 8, '3-4': 45, '3-5': 40, '3-6': 55, '3-7': 50,
  // Zone 4 (Paarl/Wellington)
  '4-1': 25, '4-2': 28, '4-3': 45, '4-4': 10, '4-5': 35, '4-6': 60, '4-7': 55,
  // Zone 5 (Northern Suburbs)
  '5-1': 30, '5-2': 32, '5-3': 40, '5-4': 35, '5-5': 10, '5-6': 25, '5-7': 20,
  // Zone 6 (Cape Town CBD)
  '6-1': 50, '6-2': 52, '6-3': 55, '6-4': 60, '6-5': 25, '6-6': 8, '6-7': 10,
  // Zone 7 (Southern Suburbs)
  '7-1': 45, '7-2': 47, '7-3': 50, '7-4': 55, '7-5': 20, '7-6': 10, '7-7': 8,
};

// Base pricing configuration
export const pricingConfig = {
  delivery: {
    basePrice: 120,        // Base price for local delivery
    perKmRate: 8,          // Rate per kilometer
    minPrice: 150,         // Minimum charge
    maxDistance: 100,      // Max distance in km
  },
  miniMove: {
    basePrice: 350,        // Base price for mini-move
    perKmRate: 12,         // Rate per kilometer
    minPrice: 450,         // Minimum charge
    maxDistance: 100,      // Max distance in km
  },
};

// Service tier multipliers
export const tierMultipliers = {
  'NOW': 1.5,        // +50% for urgent
  'TODAY': 1.0,      // Standard rate
  'TOMORROW': 0.9,   // -10% for advance booking
};

// Add-on pricing
export const addOnPricing = {
  helpers: {
    'none': 0,
    'plus1': 150,
    'plus2': 300,
  },
  stairs: {
    perFloor: 50,
    noLiftSurcharge: 100,
  },
  extraStops: 100,
  waitingTime: 50,      // per 15 minutes
  weekendSurcharge: 100,
  afterHoursSurcharge: 150,
  fragileItems: 50,
  largeItems: 100,      // appliances, large furniture
};

// Helper function to find suburb info
export const getSuburbInfo = (suburbName) => {
  if (!suburbName) return null;
  const normalized = suburbName.toLowerCase().trim();
  return suburbZones[normalized] || null;
};

// Calculate distance between two zones
export const calculateZoneDistance = (zone1, zone2) => {
  const key = `${zone1}-${zone2}`;
  return zoneDistanceMatrix[key] || 50; // Default to 50km if not found
};

// Calculate Haversine distance between two points
export const calculateHaversineDistance = (lat1, lon1, lat2, lon2) => {
  const R = 6371; // Earth's radius in km
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;
  const a = 
    Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * 
    Math.sin(dLon/2) * Math.sin(dLon/2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  return R * c;
};

// Main pricing calculator
export const calculateEstimate = ({
  serviceType = 'delivery',
  pickupSuburb = '',
  dropoffSuburb = '',
  tier = 'TODAY',
  helpers = 'none',
  stairs = 0,
  noLift = false,
  extraStops = 0,
  isWeekend = false,
  isAfterHours = false,
  hasFragile = false,
  hasLargeItems = false,
}) => {
  const config = pricingConfig[serviceType] || pricingConfig.delivery;
  
  // Get suburb info
  const pickupInfo = getSuburbInfo(pickupSuburb);
  const dropoffInfo = getSuburbInfo(dropoffSuburb);
  
  // Calculate distance
  let distance = 15; // Default distance
  let distanceSource = 'default';
  
  if (pickupInfo && dropoffInfo) {
    // Use zone-based distance if both suburbs found
    distance = calculateZoneDistance(pickupInfo.zone, dropoffInfo.zone);
    distanceSource = 'zone';
    
    // Refine with Haversine if we have coordinates
    if (pickupInfo.lat && dropoffInfo.lat) {
      const haversine = calculateHaversineDistance(
        pickupInfo.lat, pickupInfo.lng,
        dropoffInfo.lat, dropoffInfo.lng
      );
      // Use the higher of zone or haversine distance (conservative)
      distance = Math.max(distance, haversine * 1.3); // 1.3x for road vs straight-line
      distanceSource = 'calculated';
    }
  }
  
  // Base calculation
  let basePrice = config.basePrice + (distance * config.perKmRate);
  
  // Apply tier multiplier
  const tierMultiplier = tierMultipliers[tier] || 1.0;
  basePrice *= tierMultiplier;
  
  // Add-ons
  let addOns = 0;
  
  // Helpers
  addOns += addOnPricing.helpers[helpers] || 0;
  
  // Stairs
  if (stairs > 0) {
    addOns += stairs * addOnPricing.stairs.perFloor;
  }
  if (noLift) {
    addOns += addOnPricing.stairs.noLiftSurcharge;
  }
  
  // Extra stops
  addOns += extraStops * addOnPricing.extraStops;
  
  // Time-based surcharges
  if (isWeekend) addOns += addOnPricing.weekendSurcharge;
  if (isAfterHours) addOns += addOnPricing.afterHoursSurcharge;
  
  // Item-based surcharges
  if (hasFragile) addOns += addOnPricing.fragileItems;
  if (hasLargeItems) addOns += addOnPricing.largeItems;
  
  // Total
  let total = basePrice + addOns;
  
  // Apply minimum
  total = Math.max(total, config.minPrice);
  
  // Calculate range (±15%)
  const minEstimate = Math.floor(total * 0.85);
  const maxEstimate = Math.ceil(total * 1.15);
  
  return {
    estimate: {
      min: minEstimate,
      max: maxEstimate,
      midpoint: Math.round((minEstimate + maxEstimate) / 2),
    },
    breakdown: {
      basePrice: Math.round(basePrice),
      addOns: Math.round(addOns),
      distance: Math.round(distance),
      distanceSource,
      tier,
      tierMultiplier,
    },
    suburbs: {
      pickup: pickupInfo?.name || pickupSuburb,
      dropoff: dropoffInfo?.name || dropoffSuburb,
      pickupZone: pickupInfo?.zone,
      dropoffZone: dropoffInfo?.zone,
    }
  };
};

// Get all suburb names for autocomplete
export const getAllSuburbNames = () => {
  return Object.values(suburbZones).map(s => s.name);
};

export default {
  calculateEstimate,
  getSuburbInfo,
  getAllSuburbNames,
  pricingConfig,
  tierMultipliers,
  addOnPricing,
};
